import {
  DICT_LOAD
} from 'actions/dictionary';

const initialState = {
};

const dictionary = (state = initialState, action) => {
  switch (action.type) {
    case DICT_LOAD:
      let newState = {...state};
      Object.assign(newState, action.payload);
      return newState;
    default:
      return state;
  }
};

export default dictionary;


// WEBPACK FOOTER //
// ./src/reducers/dictionary.js